import { Spinner } from "@phosphor-icons/react";
import { useNavigate, useParams } from "react-router-dom";

import { EditCourseForm } from "@/components/Materials/Forms/EditCourseForm";
import { useCourses } from "@/hooks";
import { ROUTES } from "@/router/routes";
import { Breadcrumb } from "@/ui";

export const EditCourse = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const { useCourse } = useCourses();
  const { data: courseData, isLoading } = useCourse(courseId);

  const course = courseData;

  const handleClose = () => {
    navigate(ROUTES.coursesAndMaterials);
  };

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner className="animate-spin text-4xl text-primary-600" />
      </div>
    );
  }

  if (!course) {
    return <div>Course not found</div>;
  }

  return (
    <div className="flex flex-col gap-y-6 p-8">
      <Breadcrumb
        items={[
          {
            label: "Courses & Materials",
            href: ROUTES.coursesAndMaterials,
          },
          {
            label: `Edit ${course.name}`,
            href: `/courses/${courseId}/edit`,
          },
        ]}
        current={`Edit ${course.name}`}
        onItemClick={(item) => {
          if (item.href) {
            navigate(item.href);
          }
        }}
      />

      <div className="mx-auto w-full max-w-5xl rounded-xl border border-neutral-200 bg-white p-8 shadow-sm">
        <h1 className="mb-2 text-3xl font-bold text-neutral-900">
          Edit {course.name}
        </h1>
        <p className="mb-8 border-b pb-4 text-neutral-500">
          Manage course details and settings.
        </p>
        <EditCourseForm course={course} onClose={handleClose} />
      </div>
    </div>
  );
};
